import { forwardRef, useRef } from 'react'

export default forwardRef(function TextArea(
    {
        id = '',
        label = '',
        placeholder = '',
        className = '',
        error = '',
        message = '',
        ...props
    },
    ref,
) {
    const input = useRef()

    return (
        <div className={className}>
            {label && (
                <label
                    htmlFor={id}
                    className={`block mb-1 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}
                >
                    {label}
                </label>
            )}
            <div className="flex">
                <textarea
                    {...props}
                    id={id}
                    placeholder={label ? label : placeholder}
                    className={`w-full rounded-lg border bg-transparent py-2 pl-3 ${error ? 'border-danger focus:ring-danger focus:border-danger' : 'border-stroke focus:ring-primary focus:border-primary dark:border-form dark:bg-input dark:focus:ring-secondary dark:focus:border-secondary'} outline-none disabled:cursor-not-allowed disabled:bg-whiter dark:disabled:bg-black`}
                    ref={ref || input}
                />
            </div>
            {error && <p className="text-sm text-danger">{message}</p>}
        </div>
    )
})
